export const CONTAINER_MARGIN = 10;
